// ── Card compat badge styles ─────────────────────────────────────────────────
(function () {
  const style = document.createElement('style');
  style.textContent = `
    .card-compat-badge {
      display: inline-block;
      font-size: 11px;
      font-weight: 700;
      padding: 3px 8px;
      border-radius: 20px;
      margin-bottom: 6px;
      letter-spacing: 0.02em;
    }
    .card-compat-badge--fits {
      background: #e6f4ea;
      color: #1a7a34;
    }
    .card-compat-badge--no-fit {
      background: #fdecea;
      color: #c0392b;
    }
  `;
  document.head.appendChild(style);
})();

// ── Vehicle helpers ─────────────────────────────────────────────────────────
const VEHICLE_KEYS = ['vehicle_car-brand', 'vehicle_car-model', 'vehicle_car-year', 'vehicle_car-generation', 'vehicle_car-trim'];
const VEHICLE_EXPIRY_KEY = 'vehicle_saved_at';
const VEHICLE_TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 days
let vehicleClearedThisSession = false;

// ── Display name map: slug → proper label ────────────────────────────────────
const VEHICLE_LABELS = {
  'mini-cooper': 'MINI Cooper',
  'hatchback': 'Hatchback', 'clubman': 'Clubman',
  'countryman': 'Countryman', 'convertible': 'Convertible',
  '2001-2006': '2001–2006', '2007-2013': '2007–2013',
  '2007-2014': '2007–2014', '2014-2023': '2014–2023',
  '2015-2024': '2015–2024', '2024-present': '2024–Present',
  '2010-2016': '2010–2016', '2017-2023': '2017–2023',
  '2004-2008': '2004–2008', '2009-2015': '2009–2015', '2016-2023': '2016–2023',
  'r50-r53': 'Gen 1 (R50/R53)', 'r56': 'Gen 2 (R56)',
  'f56': 'Gen 3 (F56)', 'j01': 'Gen 4 (J01)',
  'r55': 'Gen 1 (R55)', 'f54': 'Gen 2 (F54)',
  'r60': 'Gen 1 (R60)', 'f60': 'Gen 2 (F60)', 'u25': 'Gen 3 (U25)',
  'r52': 'Gen 1 (R52)', 'r57': 'Gen 2 (R57)', 'f57': 'Gen 3 (F57)',
  'one': 'One', 'cooper': 'Cooper', 'cooper-s': 'Cooper S',
  'cooper-e': 'Cooper E', 'cooper-se': 'Cooper SE',
  'cooper-all4': 'Cooper ALL4', 'jcw': 'JCW'
};
window.VEHICLE_LABELS = VEHICLE_LABELS;

function slugToLabel(slug) {
  return VEHICLE_LABELS[slug] || slug.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
}

function getVehicleParts() {
  try {
    // Check expiry
    const savedAt = parseInt(localStorage.getItem(VEHICLE_EXPIRY_KEY) || '0', 10);
    if (savedAt && Date.now() - savedAt > VEHICLE_TTL_MS) {
      VEHICLE_KEYS.forEach(function (k) { localStorage.removeItem(k); });
      localStorage.removeItem(VEHICLE_EXPIRY_KEY);
      return VEHICLE_KEYS.map(function () { return ''; });
    }
    return VEHICLE_KEYS.map(function (k) { return localStorage.getItem(k) || ''; });
  } catch (e) { return VEHICLE_KEYS.map(function () { return ''; }); }
}

function setVehiclePart(key, value) {
  try {
    localStorage.setItem(key, value);
    localStorage.setItem(VEHICLE_EXPIRY_KEY, String(Date.now()));
    vehicleClearedThisSession = false;
  } catch (e) {}
}
window.setVehiclePart = setVehiclePart;

function clearVehicle() {
  try {
    VEHICLE_KEYS.forEach(function (k) { localStorage.removeItem(k); });
    localStorage.removeItem(VEHICLE_EXPIRY_KEY);
  } catch (e) {}
  vehicleClearedThisSession = true;
  window.dispatchEvent(new CustomEvent('vehicle:change'));
}
window.clearVehicle = clearVehicle;

function getVehicleLabel() {
  const parts = getVehicleParts();
  if (!parts.every(function (p) { return p !== ''; })) return null;
  return parts.map(slugToLabel).join(' · ');
}
window.getVehicleLabel = getVehicleLabel;

function getVehicleCartAttributeLabel() {
  const storedLabel = getVehicleLabel();
  const cartAttributeInput = document.querySelector('.js-vehicle-cart-input[name="attributes[Vehicle]"]');
  const existingLabel = cartAttributeInput && cartAttributeInput.value ? cartAttributeInput.value : '';
  return storedLabel || (vehicleClearedThisSession ? '' : existingLabel);
}
window.getVehicleCartAttributeLabel = getVehicleCartAttributeLabel;

function syncVehicleCartAttribute() {
  const label = getVehicleCartAttributeLabel();
  document.documentElement.classList.add('vehicle-js-ready');

  document.querySelectorAll('.js-vehicle-cart-name').forEach(function (el) {
    el.textContent = label || 'No vehicle selected';
  });

  document.querySelectorAll('.js-vehicle-cart-saved').forEach(function (el) {
    el.hidden = !label;
  });

  document.querySelectorAll('.js-vehicle-cart-empty').forEach(function (el) {
    el.hidden = !!label;
  });

  document.querySelectorAll('.js-vehicle-cart-input').forEach(function (input) {
    input.value = label || '';
    input.disabled = !label;
  });

  document.querySelectorAll('.js-vehicle-cart-action').forEach(function (button) {
    button.textContent = label ? 'Change vehicle' : 'Choose vehicle';
  });

  document.querySelectorAll('.js-vehicle-express-checkout').forEach(function (container) {
    container.hidden = !label;
  });

  document.querySelectorAll('.js-vehicle-express-lock').forEach(function (notice) {
    notice.hidden = !!label;
  });
}
window.syncVehicleCartAttribute = syncVehicleCartAttribute;

function persistVehicleToCart() {
  const label = getVehicleLabel() || '';

  return fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({
      attributes: {
        Vehicle: label,
        'Compatible with': label
      }
    })
  }).catch(function (error) {
    console.warn('Could not save vehicle to cart attributes:', error);
  });
}
window.persistVehicleToCart = persistVehicleToCart;

let syncingVehicleLineItems = false;
function syncVehicleLineItemProperties() {
  const label = getVehicleLabel();
  if (!label || syncingVehicleLineItems) return Promise.resolve();

  syncingVehicleLineItems = true;
  return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function (response) {
      if (!response.ok) throw new Error('Could not load cart');
      return response.json();
    })
    .then(function (cart) {
      return (cart.items || []).reduce(function (chain, item, index) {
        const properties = Object.assign({}, item.properties || {});
        if (properties['Compatible with'] === label) return chain;

        properties['Compatible with'] = label;
        return chain.then(function () {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              line: index + 1,
              properties: properties
            })
          });
        });
      }, Promise.resolve());
    })
    .catch(function (error) {
      console.warn('Could not sync vehicle to cart line items:', error);
    })
    .finally(function () {
      syncingVehicleLineItems = false;
    });
}
window.syncVehicleLineItemProperties = syncVehicleLineItemProperties;

function getEventProductData(trigger) {
  const scope = trigger && trigger.closest ? trigger.closest('product-info, .product, .card-wrapper, form') : null;
  const titleEl = scope && scope.querySelector ? scope.querySelector('h1, .card__heading, [data-product-title]') : null;
  return {
    product_title: titleEl ? titleEl.textContent.trim() : document.title.replace(/\s+\|.*$/, ''),
    page_path: window.location.pathname,
    page_url: window.location.href,
    vehicle: getVehicleLabel() || ''
  };
}

function trackInstaPartsEvent(name, params) {
  const payload = Object.assign({
    event_category: 'instaparts_storefront',
    vehicle: getVehicleLabel() || '',
    page_path: window.location.pathname
  }, params || {});

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(Object.assign({ event: name }, payload));

  if (typeof window.gtag === 'function') {
    window.gtag('event', name, payload);
  }

  if (typeof window.fbq === 'function') {
    window.fbq('trackCustom', name, payload);
  }

  if (
    window.Shopify &&
    window.Shopify.analytics &&
    typeof window.Shopify.analytics.publish === 'function'
  ) {
    window.Shopify.analytics.publish(name, payload);
  }

  window.dispatchEvent(new CustomEvent(name, { detail: payload }));
}
window.trackInstaPartsEvent = trackInstaPartsEvent;

// ── Inject vehicle property into product forms ───────────────────────────────
// Exposed on window so vehicle-order-details.liquid can call it safely
window.injectVehicleProperty = function (root) {
  const scope = root || document;
  scope.querySelectorAll('[data-type="add-to-cart-form"]').forEach(function (form) {
    let input = form.querySelector('input[name="properties[Compatible with]"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[Compatible with]';
      form.appendChild(input);
    }
    const label = getVehicleLabel();
    input.value = label || '';
    input.disabled = !label;
  });
};

function syncProductDynamicCheckout() {
  const label = getVehicleLabel();

  document.querySelectorAll('product-form').forEach(function (productForm) {
    productForm.querySelectorAll('.js-product-vehicle-express-checkout').forEach(function (container) {
      container.hidden = !label;
    });

    productForm.querySelectorAll('.shopify-payment-button').forEach(function (container) {
      container.hidden = !label;
    });

    productForm.querySelectorAll('.js-product-vehicle-express-lock').forEach(function (notice) {
      notice.hidden = !!label;
    });
  });
}

function setupVehicleGarageModal() {
  const modal = document.getElementById('vehicle-garage-modal');
  if (!modal) return;

  const fields = {
    brand: modal.querySelector('#garage-brand'),
    model: modal.querySelector('#garage-model'),
    year: modal.querySelector('#garage-year'),
    generation: modal.querySelector('#garage-generation'),
    trim: modal.querySelector('#garage-trim')
  };
  const saveBtn = modal.querySelector('#vehicle-garage-save');
  const clearBtn = modal.querySelector('#vehicle-garage-clear');
  const error = modal.querySelector('#vehicle-garage-error');
  const toast = document.getElementById('vehicle-garage-toast');
  let lastFocus = null;
  let toastTimer;

  function closeModal() {
    modal.hidden = true;
    document.documentElement.classList.remove('vehicle-garage-open');
    document.body.classList.remove('vehicle-garage-open');
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  modal.querySelectorAll('[data-vehicle-garage-close]').forEach(function (btn) {
    btn.addEventListener('click', closeModal);
  });

  document.addEventListener('keydown', function (event) {
    if (!modal.hidden && event.key === 'Escape') closeModal();
  });

  function openModalError(message) {
    lastFocus = document.activeElement;
    Object.keys(fields).forEach(function (key) {
      if (!fields[key]) return;
      fields[key].disabled = true;
      fields[key].innerHTML = '<option value="">Unavailable</option>';
    });
    if (saveBtn) saveBtn.disabled = true;
    if (error) {
      error.textContent = message;
      error.hidden = false;
    }
    modal.hidden = false;
    document.documentElement.classList.add('vehicle-garage-open');
    document.body.classList.add('vehicle-garage-open');
  }

  const dataNode = document.getElementById('vehicle-data');
  if (!dataNode) {
    window.openVehicleGarage = function () {
      openModalError('Vehicle options could not load. Please refresh the page or contact us on WhatsApp.');
    };
    return;
  }

  let data;
  try {
    data = JSON.parse(dataNode.textContent);
  } catch (e) {
    console.warn('Vehicle data could not be parsed:', e);
    window.openVehicleGarage = function () {
      openModalError('Vehicle options could not load. Please refresh the page or contact us on WhatsApp.');
    };
    return;
  }

  ['brands', 'models', 'years', 'generations', 'trims'].forEach(function (group) {
    (data[group] || []).forEach(function (item) {
      if (item.value && item.label) VEHICLE_LABELS[item.value] = item.label;
    });
  });

  function fillSelect(select, items, placeholder) {
    if (!select) return;
    select.disabled = true;
    select.innerHTML = '';
    const empty = document.createElement('option');
    empty.value = '';
    empty.textContent = placeholder;
    select.appendChild(empty);
    items.forEach(function (item) {
      const option = document.createElement('option');
      option.value = item.value;
      option.textContent = item.label;
      select.appendChild(option);
    });
    select.disabled = false;
  }

  function options(group, parent) {
    return (data[group] || []).filter(function (item) {
      return !parent || item.parent === parent;
    });
  }

  function refreshFrom(level) {
    if (level <= 0) {
      fillSelect(fields.model, options('models', fields.brand.value), 'Select Model');
      fields.model.value = '';
    }
    if (level <= 1) {
      fillSelect(fields.year, options('years', fields.model.value), 'Select Year');
      fields.year.value = '';
    }
    if (level <= 2) {
      fillSelect(fields.generation, options('generations', fields.year.value), 'Select Generation');
      fields.generation.value = '';
    }
    if (level <= 3) {
      fillSelect(fields.trim, options('trims', fields.generation.value), 'Select Trim');
      fields.trim.value = '';
    }
  }

  function setStoredValues() {
    const parts = getVehicleParts();
    fillSelect(fields.brand, options('brands'), 'Select Brand');
    fields.brand.value = parts[0] || '';
    fillSelect(fields.model, options('models', fields.brand.value), 'Select Model');
    fields.model.value = parts[1] || '';
    fillSelect(fields.year, options('years', fields.model.value), 'Select Year');
    fields.year.value = parts[2] || '';
    fillSelect(fields.generation, options('generations', fields.year.value), 'Select Generation');
    fields.generation.value = parts[3] || '';
    fillSelect(fields.trim, options('trims', fields.generation.value), 'Select Trim');
    fields.trim.value = parts[4] || '';
    if (error) error.hidden = true;
  }

  function openModal() {
    lastFocus = document.activeElement;
    setStoredValues();
    modal.hidden = false;
    document.documentElement.classList.add('vehicle-garage-open');
    document.body.classList.add('vehicle-garage-open');
    setTimeout(function () { if (fields.brand) fields.brand.focus(); }, 0);
  }

  window.openVehicleGarage = openModal;

  function showSavedToast() {
    if (!toast) return;
    clearTimeout(toastTimer);
    toast.hidden = false;
    toastTimer = setTimeout(function () {
      toast.hidden = true;
    }, 3600);
  }

  fields.brand.addEventListener('change', function () { refreshFrom(0); });
  fields.model.addEventListener('change', function () { refreshFrom(1); });
  fields.year.addEventListener('change', function () { refreshFrom(2); });
  fields.generation.addEventListener('change', function () { refreshFrom(3); });

  if (saveBtn) {
    saveBtn.addEventListener('click', function () {
      const values = [
        fields.brand.value,
        fields.model.value,
        fields.year.value,
        fields.generation.value,
        fields.trim.value
      ];
      if (!values.every(Boolean)) {
        if (error) error.hidden = false;
        return;
      }
      VEHICLE_KEYS.forEach(function (key, index) { setVehiclePart(key, values[index]); });
      if (error) error.hidden = true;
      window.dispatchEvent(new CustomEvent('vehicle:change'));
      trackInstaPartsEvent('instaparts_vehicle_selected', {
        vehicle_brand: slugToLabel(values[0]),
        vehicle_model: slugToLabel(values[1]),
        vehicle_year: slugToLabel(values[2]),
        vehicle_generation: slugToLabel(values[3]),
        vehicle_trim: slugToLabel(values[4])
      });
      closeModal();
      showSavedToast();
    });
  }

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      clearVehicle();
      setStoredValues();
    });
  }

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('[data-open-vehicle-garage]');
    if (!trigger) return;
    event.preventDefault();
    openModal();
  });
}

function setupVehicleCheckoutGate() {
  document.addEventListener('click', function (event) {
    const checkout = event.target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]');
    if (!checkout || checkout.disabled) return;

    if (getVehicleCartAttributeLabel()) {
      if (checkout.matches('a[href*="/checkout"]') && getVehicleLabel()) {
        event.preventDefault();
        event.stopPropagation();
        persistVehicleToCart().finally(function () {
          window.location.href = checkout.href;
        });
      }
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    if (typeof window.openVehicleGarage === 'function') window.openVehicleGarage();
  }, true);

  document.addEventListener('submit', function (event) {
    const form = event.target;
    const checkoutSubmitter = event.submitter && event.submitter.matches
      ? event.submitter.matches('button[name="checkout"], input[name="checkout"]')
      : !!(form && form.querySelector('button[name="checkout"], input[name="checkout"]'));

    if (!form || !checkoutSubmitter || getVehicleCartAttributeLabel()) return;

    event.preventDefault();
    if (typeof window.openVehicleGarage === 'function') window.openVehicleGarage();
  }, true);
}

// ── Collection card compat badges ────────────────────────────────────────────
function badgeCards(root) {
  const scope = root || document;
  const parts = getVehicleParts();
  const filled = parts.every(function (p) { return p !== ''; });
  const vehicleKey = parts.join('|').toLowerCase();
  const legacyVehicleKey = parts.slice(0, 4).join('|').toLowerCase();

  scope.querySelectorAll('.card-compat-badge').forEach(function (badge) {
    const card = badge.closest('[data-vehicles]');
    if (!card) return;

    if (!filled) {
      badge.textContent = '';
      badge.className = 'card-compat-badge';
      return;
    }

    const vehicles = card.dataset.vehicles.split(',').map(function (v) { return v.trim().toLowerCase(); });
    const fits = vehicles.some(function (v) { return v === vehicleKey || v === legacyVehicleKey; });

    badge.textContent = fits ? '✓ Fits your vehicle' : '✗ Check compatibility';
    badge.className = 'card-compat-badge card-compat-badge--' + (fits ? 'fits' : 'no-fit');
  });
}

// ── Debounced MutationObserver callback ──────────────────────────────────────
// Named differently from the theme's global `debounce` (assets/global.js) so it
// doesn't overwrite it — that shared one is relied on by facets.js/cart.js to
// forward the triggering event, and this file loads after global.js.
function debounceMutations(fn, ms) {
  let timer;
  return function () {
    clearTimeout(timer);
    timer = setTimeout(fn, ms);
  };
}

function ensureHomepageNewArrivals() {
  const path = window.location.pathname.replace(/\/+$/, '') || '/';
  if (path !== '/') return;

  const hasNewArrivals = Array.from(document.querySelectorAll('.collection__title h2, .collection__title .title'))
    .some(function (title) { return title.textContent.trim().toLowerCase() === 'new arrivals'; });
  if (hasNewArrivals) return;

  const bestSellerTitle = Array.from(document.querySelectorAll('.collection__title h2, .collection__title .title'))
    .find(function (title) { return title.textContent.trim().toLowerCase() === 'best sellers'; });
  const bestSellerSection = bestSellerTitle && bestSellerTitle.closest('.shopify-section, .gradient');
  if (!bestSellerSection) return;

  fetch('/?view=default&_fd=0&new_arrivals_fallback=' + Date.now(), {
    credentials: 'same-origin'
  })
    .then(function (response) {
      if (!response.ok) throw new Error('New arrivals fallback request failed');
      return response.text();
    })
    .then(function (html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const remoteTitle = Array.from(doc.querySelectorAll('.collection__title h2, .collection__title .title'))
        .find(function (title) { return title.textContent.trim().toLowerCase() === 'new arrivals'; });
      const remoteSection = remoteTitle && remoteTitle.closest('.gradient');
      if (!remoteSection) return;

      bestSellerSection.insertAdjacentHTML('beforebegin', remoteSection.outerHTML);
      const insertedSection = bestSellerSection.previousElementSibling;
      if (insertedSection) badgeCards(insertedSection);
    })
    .catch(function () {});
}

// ── DOMContentLoaded ─────────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', function () {

  setupVehicleGarageModal();
  setupVehicleCheckoutGate();
  window.injectVehicleProperty();
  syncProductDynamicCheckout();
  syncVehicleCartAttribute();
  syncVehicleLineItemProperties();
  badgeCards();
  ensureHomepageNewArrivals();

  // Re-run when vehicle changes in another tab
  window.addEventListener('storage', function (e) {
    if (!VEHICLE_KEYS.includes(e.key)) return;
    window.injectVehicleProperty();
    syncProductDynamicCheckout();
    syncVehicleCartAttribute();
    badgeCards();
  });
  window.addEventListener('vehicle:change', function () {
    window.injectVehicleProperty();
    syncProductDynamicCheckout();
    syncVehicleCartAttribute();
    persistVehicleToCart();
    syncVehicleLineItemProperties();
    badgeCards();
  });

  document.addEventListener('click', function (event) {
    const link = event.target.closest('a[href*="wa.me"], a[href*="whatsapp"]');
    if (!link) return;

    trackInstaPartsEvent('instaparts_whatsapp_click', Object.assign(getEventProductData(link), {
      link_url: link.href,
      link_text: link.textContent.trim()
    }));
  });

  document.addEventListener('click', function (event) {
    const link = event.target.closest('a[href*="/collections/new-arrivals"]');
    if (!link) return;

    trackInstaPartsEvent('instaparts_new_arrivals_click', {
      link_url: link.href,
      link_text: link.textContent.trim()
    });
  });

  document.addEventListener('click', function (event) {
    const button = event.target.closest('button[name="add"], .upsell-add-to-cart-btn');
    if (!button || button.disabled) return;

    trackInstaPartsEvent('instaparts_add_to_cart_attempt', getEventProductData(button));
  });

  document.addEventListener('click', function (event) {
    const checkout = event.target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]');
    if (!checkout || checkout.disabled) return;

    trackInstaPartsEvent('instaparts_checkout_click', {
      vehicle_present: !!getVehicleCartAttributeLabel(),
      cart_url: window.location.href
    });
  });

  // Catch quick-add modal and dynamically injected forms/cards — debounced
  var handleMutations = debounceMutations(function () {
    window.injectVehicleProperty();
    syncProductDynamicCheckout();
    syncVehicleCartAttribute();
    badgeCards();
  }, 100);

  new MutationObserver(function (mutations) {
    var hasRelevantNode = mutations.some(function (m) {
      return Array.from(m.addedNodes).some(function (n) { return n.nodeType === 1; });
    });
    if (hasRelevantNode) handleMutations();
  }).observe(document.body, { childList: true, subtree: true });

  // ── Upsell add-to-cart ──────────────────────────────────────────────────
  document.querySelectorAll('.upsell-add-to-cart-btn').forEach(function (button) {
    button.addEventListener('click', function () {
      const variantId = this.dataset.variantId;
      const label = getVehicleLabel();

      const item = { id: variantId, quantity: 1 };
      if (label) item.properties = { 'Compatible with': label };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [item] })
      })
      .then(function (response) {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.json();
      })
      .catch(function (error) {
        console.error('Error adding items to cart:', error);
      })
      .finally(function () {
        const cartDrawer = document.querySelector('cart-drawer');
        const cartbtn = document.querySelector('.header__icon.header-cart-icon');
        if (cartbtn) cartbtn.click();
        if (cartDrawer && typeof cartDrawer.refresh === 'function') cartDrawer.refresh(true);
      });
    });
  });

});
